var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Controller, useForm } from "react-hook-form";
import Modal from "../../UI/Modal/Modal";
import useService from "../../Hooks/useService";
import CoachService from "../../../Services/Coach.service";
import ModalHeader from "../../UI/Modal/ModalHeader";
import ValidationService from "../../../Services/Shared/Validation.service";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import { CancelButton, SaveButton, } from "../../UI/StandardButtons/StandardButtons";
import DeprecatedSelect from "../../UI/DeprecatedSelect/DeprecatedSelect";
const EditCoachModal = (_a) => {
    var { termToRepresentCoach, currentCoach, studentAffiliationId, onEdit } = _a, modalProps = __rest(_a, ["termToRepresentCoach", "currentCoach", "studentAffiliationId", "onEdit"]);
    const { errors, control, handleSubmit } = useForm({
        // @ts-expect-error - TS2322 - Type 'PersonLite | null | undefined' is not assignable to type 'DeepPartial<PersonLite> | undefined'.
        defaultValues: { coach: currentCoach },
    });
    const [assignCoachState, assignCoach] = useService(CoachService.assignCoach);
    const submit = (state) => {
        // assign coach
        assignCoach(studentAffiliationId, state.coach.affiliationId).then(() => {
            modalProps.onModalClosed();
            onEdit(state.coach);
        });
    };
    return (_jsxs(Modal, Object.assign({}, modalProps, { children: [_jsx(ModalHeader, { title: `Edit ${termToRepresentCoach}`, closeModal: modalProps.onModalClosed }), modalProps.isOpen && (_jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: "modal-body", children: [_jsxs("div", { className: "form-group", children: [_jsx("label", { children: termToRepresentCoach }), _jsx(Controller, { as: _jsx(DeprecatedSelect.Async, { loadOptions: (query) => CoachService.search(query).then((options) => ({
                                                options,
                                            })), clearable: false, valueKey: "id", labelKey: "fullName", placeholder: "Unassigned", className: ValidationService.makeClassName(errors, "coach") }), control: control, name: "coach", rules: {
                                            // @ts-expect-error - TS7006 - Parameter 'coach' implicitly has an 'any' type.
                                            validate: (coach) => currentCoach && currentCoach.personId !== coach.personId,
                                        } }), _jsxs("div", { className: "invalid-feedback", children: ["Please pick a different ", termToRepresentCoach] })] }), assignCoachState.hasError && (_jsx(AlertError, { message: "There was an error assigning this coach", detail: assignCoachState.errorMessage }))] }), _jsxs("div", { className: "modal-footer", children: [_jsx(SaveButton, { type: "submit", isLoading: assignCoachState.isLoading }), _jsx(CancelButton, { onClick: () => modalProps.onModalClosed() })] })] }))] })));
};
export default EditCoachModal;
